export const headLoadings = new Array(6).fill('');
export const bodyColumnLoadings = new Array(5).fill('');
export const bodyRowItemLoadings = new Array(6).fill('');
